<template>
  <div
    class="contenedor d-flex flex-column justify-content-center align-items-center spinner-container"
  >
    <span v-if="title" class="text-primary"> {{ title }} </span>
    <img
      src="@/assets/images/search_oliver.gif"
      alt="Recherche en cours..."
      class="loading-search-gif"
    >
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
};
</script>

<style scoped>
.loading-search-gif {
  max-width: 500px;
  max-height: 500px;
  object-fit: contain;
}
</style>